<template>
  <IQOSModal>
    <template #title>
      {{ $t("modificators_merge_modal.title") }}
    </template>
    <div class="v1-grey-5-color">
      <BaseSelect fullWidth class="mt-16" v-model="selected_group">
        <option :value="null" disabled>
          {{ $t("modificators_merge_modal.group_ph") }}
        </option>
        <option
          v-for="(g, index) in priceGroupsSelection"
          :key="g._id"
          :value="g._id"
        >
          {{
            g.name ||
            $t("modificators_settings.variant_name") + " (" + (index + 1) + ")"
          }}
        </option>
      </BaseSelect>

      <BaseSelect fullWidth class="mt-8" v-model="link_id">
        <option :value="null">
          {{ $t("modificators_merge_modal.mod_ph") }}
        </option>
        <option
          v-for="(item,item_index) in groupItemsSelection"
          :key="item._id+'-'+item_index"
          :value="item._id"
        >
          {{ item.name || `${$t('modificators_settings.name_ph')} №${item_index+1}` }}
        </option>
      </BaseSelect>

      <div class="iqos-comment qrw-paragraph-md mt-16">
        {{ $t("modificators_merge_modal.info1") }}
      </div>

      <div class="iqos-comment qrw-paragraph-md mt-8">
        {{ $t("modificators_merge_modal.info2") }}
      </div>
    </div>

    <template #actions>
      <BaseButton
        variant="secondary"
        color="v1-grey-5"
        size="md"
        @click="onClose"
        >{{ $t("add_modificator_group_modal.cancel") }}</BaseButton
      >
      <BaseButton
        variant="secondary"
        color="v1-grey-5"
        size="md"
        @click="onConfirm"
        :disabled="!link_id"
        >{{ $t("add_modificator_group_modal.merge") }}</BaseButton
      >
    </template>
  </IQOSModal>
</template>

<script>
export default {
  props: {
    group_id: String,
  },
  data() {
    return {
      link_id: null,

      selected_group: null,
    };
  },
  methods: {
    onClose() {
      this.$emit("close");
    },
    onConfirm() {
      this.$store.commit("menu/setPriceGroupData", {
        id: this.group_id,
        key: "show_for",
        value: [
          ...this.dish.price_groups.find((g) => g._id == this.group_id).show_for || [],
          this.link_id,
        ],
      });
      this.$store.dispatch("menu/updateProduct");
      this.onClose();
    },
  },
  computed: {
    dish() {
      return this.$store.state.menu.product;
    },
    priceGroupsSelection() {
      return this.dish.price_groups.filter((g) => g._id != this.group_id);
    },
    currentAssignedIds() {
      return (this.dish.price_groups
        .find((g) => g._id == this.group_id)
        .show_for || []).map((id) => id);
    },
    groupItemsSelection() {
      if (!this.selected_group) return null;

      return this.priceGroupsSelection.find((g) => g._id == this.selected_group)
        .items.filter(it => !this.currentAssignedIds.includes(it._id));
    },
  },
  mounted() {
    this.$store.dispatch("menu/fetchMenus");
  },
};
</script>

<style scoped>
h4.title {
  font-size: 2.3vh;
}

p {
  line-height: normal;
  margin: 0;
}

select {
  width: 100%;
  height: 4vh;
  padding: 0.3vh;
  border-radius: 0.8vh;
  color: #908f8d;
  outline: none;
}

.buttons-container {
  display: flex;
  justify-content: space-between;
  margin-top: 2.2vh;
}
</style>
